import { createBrowserHistory } from 'history'
import { isCorporateEventsHostname } from 'corporateEvents/utils/corporateEventsRoutes'
import { pathnameHasRegionCode } from 'lib/string/regionUtils'
import { addRegionToPath } from 'lib/url/searchUrlUtils'

function initialiseHistory(regionCode: string, hostname?: string) {
  const history = createBrowserHistory()
  if (isCorporateEventsHostname(hostname)) {
    return history
  }

  // Trust the SSR region code, if the region code isn't in the url - replace it in
  if (!pathnameHasRegionCode(history.location.pathname, regionCode)) {
    const nextLocation = { ...history.location }
    nextLocation.pathname = addRegionToPath(nextLocation.pathname, regionCode)
    history.replace(nextLocation)
  }

  return history
}

export default initialiseHistory
